import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=ac54a20e&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=ts&"
export * from "./SideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=ac54a20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac54a20e",
  null
  
)

export default component.exports